// this is a hard coded list of supported languages 
// please update when new languages are added
// this is used by react-components because we dont want to load all language json every load but just have the key names
export const SUPPORTED_LANGUAGES = [
  {
      "key": "en-au",
      "name": "Australia",
      "nativeName": "Australia"
  },
  {
      "key": "nl-be",
      "name": "Belgium (Dutch)",
      "nativeName": "België"
  },
  {
      "key": "pt-br",
      "name": "Brazil",
      "nativeName": "Brasil"
  },
  {
      "key": "en-ca",
      "name": "Canada (English)",
      "nativeName": "Canada (English)"
  },
  {
      "key": "fr-ca",
      "name": "Canada (French)",
      "nativeName": "Canada (Français)"
  },
  {
      "key": "de-de",
      "name": "German",
      "nativeName": "Deutschland"
  },
  {
      "key": "da-dk",
      "name": "Danish",
      "nativeName": "Danmark"
  },
  {
      "key": "es-us",
      "name": "United States (Spanish)",
      "nativeName": "USA (Español)"
  },
  {
      "key": "es-es",
      "name": "Spain",
      "nativeName": "España"
  },
  {
      "key": "fr-fr",
      "name": "France",
      "nativeName": "France"
  },
  {
      "key": "bn-in",
      "name": "Bengali (India)",
      "nativeName": "ভারত"
  },
  {
      "key": "hi-in",
      "name": "Hindi (India)",
      "nativeName": "भारत"
  },
  {
      "key": "en-ie",
      "name": "Ireland",
      "nativeName": "Ireland"
  },
  {
      "key": "it-it",
      "name": "Italy",
      "nativeName": "Italia"
  },
  {
      "key": "nl-nl",
      "name": "Netherlands",
      "nativeName": "Nederland"
  },
  {
      "key": "en-nz",
      "name": "New Zealand",
      "nativeName": "New Zealand"
  },
  {
      "key": "en-gb",
      "name": "United Kingdom",
      "nativeName": "United Kingdom"
  },
  {
      "key": "en-us",
      "name": "English",
      "nativeName": "USA"
  },
  {
      "key": "ja-jp",
      "name": "Japan",
      "nativeName": "日本"
  },
  {
      "key": "zh-hk",
      "name": "Hong Kong (Traditional)",
      "nativeName": "香港"
  },
  {
      "key": "zh-cn",
      "name": "China (Simplified)",
      "nativeName": "简体中文"
  },
  {
      "key": "ko-kr",
      "name": "Korea (South)",
      "nativeName": "대한민국"
  }
]